export default __webpack_public_path__ + "static/media/star.35593304.svg";